import DescriptionIcon from "@material-ui/icons/Description";
import FolderIcon from "@material-ui/icons/Folder";
import ImageIcon from "@material-ui/icons/Image";
import ListAltIcon from "@material-ui/icons/ListAlt";
import React from "react";

type Props = {
	droppable: boolean;
	fileType?: string;
};

export const TypeIcon: React.FC<Props> = (props) => {
	if (props.droppable) {
		return <FolderIcon />;
	}

	switch (props.fileType) {
		case "image":
			return <ImageIcon />;
		case "csv":
			return <ListAltIcon />;
		case "text":
			return <DescriptionIcon />;
		default:
			return null;
	}
};
